import { MacroData } from '../types/zoneMapType';
import { filterFixtureIds } from './zoneMapDataHelper';
import { FloorplanFixtureData } from './zoneMapDataType';

/**
 *
 * Filter Zone Data for CopyToNew with following rule:
 *  Filter out fxture which is in past zone data but not in current zone map
 *  For example:
 *     past zone data: apple zone has table1 and table2
 *     zone map has table1
 *  after filtering, apple zone has table1 since current Floorplan only has tabl1
 */
const filterZoneData = (zoneNameList: MacroData[], agileFixtures: FloorplanFixtureData[]) =>
  zoneNameList.map((zone) => ({
    ...zone,
    unParsedFixtureIds: filterFixtureIds(zone.unParsedFixtureIds, agileFixtures),
  }));

export default filterZoneData;
